var youbora = require('youboralib')
var manifest = require('../../manifest.json')

var GenericAdsAdapter = youbora.Adapter.extend({
  getVersion: function () {
    return manifest.version + '-jwplayer7-ads'
  },

  getDuration: function () {
    return this.duration
  },

  getResource: function () {
    return this.resource
  },

  getPlayhead: function () {
    return this.playhead
  },

  getTitle: function () {
    return this.title
  },

  getPosition: function () {
    if (this.position) {
      return this.position
    } else if (this.flags.isJoined) {
      return 'mid'
    } else {
      return 'pre'
    }
  },

  registerListeners: function () {
    // Register listeners
    // Enable playhead monitor (buffer = true, seek = false)
    this.monitorPlayhead(true, false, 1200)

    this.player.on('adTime', this.adTimeListener.bind(this))
    this.player.on('adStarted', this.adStartedListener.bind(this))
    this.player.on('adImpression', this.adImpressionListener.bind(this))
    this.player.on('adPause', this.adPauseListener.bind(this))
    this.player.on('adPlay', this.adPlayListener.bind(this))
    this.player.on('adSkipped', this.adSkippedListener.bind(this))
    this.player.on('adComplete', this.adCompleteListener.bind(this))
    this.player.on('adClick', this.adClickListener.bind(this))
    this.player.on('adError', this.adErrorListener.bind(this))
  },

  adTimeListener: function (e) {
    this.playhead = e.position
    this.duration = e.duration
    if (this.plugin._adapter) this.plugin._adapter.firePause()
    this.fireStart()
    this.fireJoin()
  },

  adStartedListener: function (e) {
    this.position = e.adposition
    this.resource = e.tag
    this.title = e.adtitle
  },

  adImpressionListener: function (e) {
    this.position = e.adposition
    this.resource = e.tag
    this.title = e.adtitle
  },

  adPauseListener: function (e) {
    this.firePause()
  },

  adPlayListener: function (e) {
    this.fireResume()
  },

  adSkippedListener: function (e) {
    this.fireStop({ skipped: true })
    if (this.plugin._adapter) this.plugin._adapter.fireResume()
  },

  adCompleteListener: function (e) {
    this.fireStop()
    if (this.plugin._adapter) this.plugin._adapter.fireResume()
    this.resetValues()
  },

  adClickListener: function (e) {
    this.fireClick() // e.tag is the link clicked
  },

  adErrorListener: function (e) {
    this.fireError(e.message)
  },

  unregisterListeners: function () {
    // unregister listeners
    this.player.off('adTime', this.adTimeListener)
    this.player.off('adStarted', this.adStartedListener)
    this.player.off('adImpression', this.adImpressionListener)
    this.player.off('adPause', this.adPauseListener)
    this.player.off('adPlay', this.adPlayListener)
    this.player.off('adSkipped', this.adSkippedListener)
    this.player.off('adComplete', this.adCompleteListener)
    this.player.off('adClick', this.adClickListener)
    this.player.off('adError', this.adErrorListener)
  },

  resetValues: function () {
    this.playhead = undefined
    this.duration = undefined
    this.position = undefined
    this.resource = undefined
    this.title = undefined
  }

})

module.exports = GenericAdsAdapter



//////////////////
// WEBPACK FOOTER
// ./src/ads/native.js
// module id = 53
// module chunks = 0